import {
  APIConstraintEnforcementMode,
  APIReferenceAttributes,
  APIReferenceType,
} from '@ardoq/api-types';
import {
  IntendedRefTypes,
  getBlockedRefTypeMessage,
  isRefTypeViolation,
} from 'utils/metamodelConstraints';

export interface ReverseConstraintViolation {
  violates: boolean;
  isBlocked: boolean;
  isWarning: boolean;
  message: string;
}

export const noConstraintViolation: ReverseConstraintViolation = {
  violates: false,
  isBlocked: false,
  isWarning: false,
  message: '',
};

export type ConstraintViolationArgs = {
  reference: APIReferenceAttributes | undefined;
  referenceTypes: readonly APIReferenceType[];
  sourceTypeName: string | null;
  targetTypeName: string | null;
  intendedRefTypes: IntendedRefTypes | null;
  constraintEnforcementMode: APIConstraintEnforcementMode;
};

export const calculateConstraintViolation = ({
  reference,
  referenceTypes,
  sourceTypeName,
  targetTypeName,
  intendedRefTypes,
  constraintEnforcementMode,
}: ConstraintViolationArgs): ReverseConstraintViolation => {
  if (!reference) {
    return noConstraintViolation;
  }

  if (!intendedRefTypes) {
    return noConstraintViolation;
  }

  const hasConstraintsEnabled =
    constraintEnforcementMode === 'warning' ||
    constraintEnforcementMode === 'strict';

  if (!hasConstraintsEnabled) {
    return noConstraintViolation;
  }

  const referenceTypeName =
    referenceTypes.find(refType => refType.id === reference.type)?.name ?? null;

  const violates = isRefTypeViolation(
    intendedRefTypes,
    targetTypeName ?? '',
    sourceTypeName ?? '',
    referenceTypeName ?? ''
  );

  return {
    violates,
    isBlocked: violates && constraintEnforcementMode === 'strict',
    isWarning: violates && constraintEnforcementMode === 'warning',
    message: getBlockedRefTypeMessage(
      referenceTypeName,
      sourceTypeName,
      targetTypeName
    ),
  };
};
